import { render, staticRenderFns } from "./supplierInfoDetails.vue?vue&type=template&id=11f16fdf&scoped=true"
import script from "./supplierInfoDetails.vue?vue&type=script&lang=js"
export * from "./supplierInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./supplierInfoDetails.vue?vue&type=style&index=0&id=11f16fdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f16fdf",
  null
  
)

export default component.exports